/** @jsx jsx */
import { jsx, Link } from 'theme-ui'
import { Link as GatsbyLink } from 'gatsby'
import { any, string, func, bool } from 'prop-types'
import DistribionLink from './DistribionLink'
import { useBreakpoint } from '../../utils/useWindowWidth'
import isFeatureVisible from '../../utils/checkFeatureVisibility'
import { Fragment, useEffect, useState } from 'react'
import parseLinkTokens from '../../utils/parseLinkTokens'
import FeatureCard from '../homepage/features/FeatureCard'
import {
  defaultDistribionLink,
  GET_DISTRIBION_DATA_TO_POST,
} from '../../utils/getDistribionLink'
import { useLazyQuery } from '@apollo/client'
import ContentCard from '../homepage/ContentCard'

const ParseLink = ({
  id,
  title,
  text,
  slug,
  closeMobileModal,
  image,
  isFeatureList,
  isNewContent,
  description,
  descriptionRichText,
  cardIcon,
  isMenuLink,
  isSocialMediaButton,
  mainSectionButtonText,
  mainSectionButtonLink,
  subSectionButtonLink,
  subSectionButtonText,
  subSectionHeadline,
}) => {
  const breakpoint = useBreakpoint()
  const isDesktop = breakpoint === 'desktop'
  const isLinkVisible = isFeatureVisible(text, isDesktop)
  const [distribionData, setDistribionData] = useState(null)
  const [getDistribionData, { data }] = useLazyQuery(
    GET_DISTRIBION_DATA_TO_POST,
    {
      variables: {
        distribionResourceUrl: slug
          .toLowerCase()
          .includes('https://studiotoolkit')
          ? slug
          : defaultDistribionLink,
      },
      fetchPolicy: 'no-cache',
    }
  )

  useEffect(() => {
    if (data?.distribionSamlResponse) {
      setDistribionData(data)
    }
  }, [data])
  useEffect(() => {
    getDistribionData()
  }, [])
  if (isNewContent) {
    return slug.includes('/app') || slug.includes('/article') ? (
      <Link
        href={slug}
        sx={{
          variant: 'links.none',
          maxWidth: '30%',
          pl: 0,
          pt: 2,
        }}
      >
        <ContentCard
          title={text}
          imageUrl={image.file.url}
          imageDescription={image.description}
          subTitle={description}
          url={slug}
        />
      </Link>
    ) : (
      <Link
        href={slug}
        target="_blank"
        rel="noopener noreferrer"
        sx={{
          minWidth: 'unset',
          color: 'inherit',
          maxWidth: '30%',
          pl: 0,
          pt: 2,
        }}
      >
        <ContentCard
          title={text}
          imageUrl={image.file.url}
          imageDescription={image.description}
          subTitle={description}
          url={slug}
        />
      </Link>
    )
  } else if (slug.toLowerCase().includes(parseLinkTokens?.COMMONWEALTH)) {
    const uri = `${process.env.GATSBY_COMMLINK_URL}/Login/auto/autoLogin.aspx?SendMeHere=${slug}`
    return (
      <Link
        target={text === 'Commonwealth Link' ? '_blank' : undefined}
        key={id}
        href={uri}
        sx={{ variant: 'links.navigation' }}
      >
        {isFeatureList ? (
          <FeatureCard
            icon={`https:${cardIcon?.file?.url}`}
            subTitle={description}
            descriptionRichText={descriptionRichText}
            title={text}
            isSocialMediaButton={isSocialMediaButton}
          />
        ) : (
          <span>{text}</span>
        )}
      </Link>
    )
  } else if (slug.toLowerCase() === parseLinkTokens?.DISTRIBION) {
    return isFeatureList ? (
      <div key={id} sx={{ height: '100%' }}>
        <FeatureCard
          icon={`https:${cardIcon?.file.url}`}
          subTitle={description}
          descriptionRichText={descriptionRichText}
          title={text}
          isSocialMediaButton={isSocialMediaButton}
          isRedirectContentLink={true}
          redirectSource={distribionData}
        />
        {/* {distribionData && (
          <ResourceModalButton
            distribionFormVisible={distribionFormVisible}
            setDistribionFormVisible={setDistribionFormVisible}
            formSubmitted={formSubmitted}
            setFormSubmitted={setFormSubmitted}
            data={distribionData}
          />
        )} */}
      </div>
    ) : (
      <div key={id}>
        <DistribionLink text={text} />
      </div>
    )
  } else if (slug.toLowerCase().includes(parseLinkTokens?.EASYSITE)) {
    return isFeatureList ? (
      <Link
        key={id}
        target="_blank"
        href={`${process.env.GATSBY_COMMLINK_URL}/Login/auto/autoLogin.aspx?SendMeHere=${process.env.GATSBY_COMMLINK_URL}/applications/SingleSignOn/EasySite/SSO/Launch`}
        sx={{ color: 'black', textDecoration: 'none', height: '100%' }}
      >
        <FeatureCard
          icon={`https:${cardIcon?.file?.url}`}
          subTitle={description}
          descriptionRichText={descriptionRichText}
          title={text}
          isSocialMediaButton={isSocialMediaButton}
        />
      </Link>
    ) : (
      <Link
        target={text === 'Commonwealth Link' ? '_blank' : undefined}
        key={id}
        href={`${process.env.GATSBY_COMMLINK_URL}/Login/auto/autoLogin.aspx?SendMeHere=${process.env.GATSBY_COMMLINK_URL}/applications/SingleSignOn/EasySite/SSO/Launch`}
        sx={{ variant: 'links.navigation' }}
      >
        <span>{text}</span>
      </Link>
    )
  } else if (isFeatureList && slug.toLowerCase().includes('https://')) {
    return (
      <Link
        key={id}
        href={isFeatureVisible(title, isDesktop) ? slug : null}
        sx={{ color: 'black', textDecoration: 'none', height: '100%' }}
      >
        <FeatureCard
          icon={`https:${cardIcon?.file?.url}`}
          subTitle={description}
          descriptionRichText={descriptionRichText}
          title={text}
          isFeatureVisible={isFeatureVisible(title, isDesktop)}
          isSocialMediaButton={isSocialMediaButton}
        />
      </Link>
    )
  } else if (isFeatureList && isFeatureVisible(title, isDesktop)) {
    if (mainSectionButtonLink) {
      return (
        <FeatureCard
          icon={`https:${cardIcon?.file?.url}`}
          subTitle={description}
          descriptionRichText={descriptionRichText}
          title={text}
          entityName={title}
          isFeatureVisible={true}
          isSocialMediaButton={isSocialMediaButton}
          subSectionHeadline={subSectionHeadline}
          subSectionButtonText={subSectionButtonText}
          subSectionButtonLink={subSectionButtonLink}
          mainSectionButtonLink={mainSectionButtonLink}
          mainSectionButtonText={mainSectionButtonText}
        />
      )
    }
    return (
      <GatsbyLink
        key={id}
        to={slug}
        sx={{ color: 'black', textDecoration: 'none', height: '100%' }}
        state={{ thirdPartyVendor: '2' }} //2 because that is the id of third-party vendor assettype
      >
        <FeatureCard
          icon={`https:${cardIcon?.file?.url}`}
          subTitle={description}
          descriptionRichText={descriptionRichText}
          title={text}
          entityName={title}
          isFeatureVisible={true}
          isSocialMediaButton={isSocialMediaButton}
          subSectionHeadline={subSectionHeadline}
          subSectionButtonText={subSectionButtonText}
          subSectionButtonLink={subSectionButtonLink}
          mainSectionButtonLink={mainSectionButtonLink}
          mainSectionButtonText={mainSectionButtonText}
        />
      </GatsbyLink>
    )
  } else if (slug.toLowerCase().includes(parseLinkTokens?.COMMLINK)) {
    return (
      <Link
        key={id}
        target="_blank"
        href={`${process.env.GATSBY_COMMLINK_URL}/applications/CommLink/RegisterRedirect.aspx`}
        sx={{ variant: 'links.navigation' }}
      >
        <span>{text}</span>
      </Link>
    )
  } else if (isMenuLink) {
    if (isLinkVisible) {
      return (
        <GatsbyLink
          key={id}
          sx={{ variant: 'links.navigation' }}
          to={slug}
          onClick={closeMobileModal}
          state={{ thirdPartyVendor: '2' }} //2 because that is the id of third-party vendor assettype
          target={
            slug.toLowerCase().includes('https://studiotoolkit')
              ? '_blank'
              : '_self'
          }
        >
          <span>{text}</span>
        </GatsbyLink>
      )
    } else {
      return null
    }
  } else if (slug.toLowerCase().includes('https://studiotoolkit')) {
    return (
      <Fragment>
        <DistribionLink key={id} title={title} url={slug} text={text} />
      </Fragment>
    )
  } else if (slug.toLowerCase().includes('http')) {
    return (
      <Link
        target={text === 'COMMunity Link' ? '_blank' : undefined}
        key={id}
        href={slug}
        sx={{ variant: 'links.navigation' }}
      >
        <span>{text}</span>
      </Link>
    )
  } else {
    return (
      <FeatureCard
        key={id}
        icon={`https:${cardIcon?.file?.url}`}
        subTitle={description}
        descriptionRichText={descriptionRichText}
        title={text}
        entityName={title}
        isFeatureVisible={false}
        isSocialMediaButton={isSocialMediaButton}
      />
    )
  }
}

ParseLink.propTypes = {
  id: any.isRequired,
  title: string,
  text: any.isRequired,
  slug: any.isRequired,
  image: any,
  isMenuLink: bool,
  isFeatureList: bool,
  isNewContent: bool,
  children: any,
  description: string,
  descriptionRichText: any,
  cardIcon: any,
  closeMobileModal: func,
  isSocialMediaButton: bool,
  subSectionButtonLink: string,
  subSectionButtonText: string,
  subSectionHeadline: string,
  mainSectionButtonText: string,
  mainSectionButtonLink: string,
}

export default ParseLink
